import { AutoComplete } from 'antd';
import type { OptionEntity } from 'domain/entities/OptionEntity';
import { useRef } from 'react';
import styles from './form.module.scss';

type AutoCompleteInputProps = {
    value?: string;
    options: OptionEntity[];
    placeholder?: string;
    notFoundContent?: string;
    allowClear?: boolean;
    onChange?: (value: string) => void;
    onSelect?: (option: OptionEntity | undefined) => void;
    onBlur?: (option: OptionEntity | undefined) => void;
};

const defaultFilter = (input: string, option: any) =>
    option?.label?.toUpperCase().indexOf(input.toUpperCase()) !== -1;

export const AutoCompleteInput = ({
    value,
    options,
    placeholder,
    notFoundContent,
    allowClear = false,
    onChange,
    onSelect,
    onBlur,
}: AutoCompleteInputProps) => {
    const currentSearchRef = useRef<string>(value ?? '');

    return (
        <div className={styles.autoCompleteWrapper}>
            <AutoComplete
                value={value}
                options={options}
                placeholder={placeholder}
                notFoundContent={notFoundContent}
                allowClear={allowClear}
                showSearch
                size="large"
                filterOption={defaultFilter}
                onSearch={(val) => {
                    currentSearchRef.current = val;
                }}
                onSelect={(val) => {
                    const opt = options.find((o) => String(o.value) === String(val));
                    const label = opt?.label ?? val;
                    currentSearchRef.current = label;
                    onChange?.(label);
                    onSelect?.(opt);
                }}
                onBlur={() => {
                    const text = currentSearchRef.current;
                    const opt = options.find(
                        (o) => o.label === text || String(o.value) === String(text),
                    );
                    onBlur?.(opt);
                }}
                onChange={(val) => {
                    currentSearchRef.current = val;
                    onChange?.(val);
                }}
            />
        </div>
    );
};
